export default "__VITE_ASSET__CLNdRAIq__"